export default {
  methods: {
    trackSubAccountActivity: function(subAccountId,activityType){
      let url = `/api/v1/subaccounts/${subAccountId}/activity/${activityType}`;
      return fetch(url, {
          method: "POST",
          credentials: "include",
        });
    }
  },
}